import React from "react";

export default function EmergencyContactsModal({ open, onClose, userData }) {
  if (!open) return null;

  const emergencyContacts = userData?.EmergencyContacts
    ? Array.from(
        new Map(
          Object.values(userData.EmergencyContacts).map((contact) => [contact.phoneNumber, contact])
        ).values()
      )
    : [];

  return (
    <>
      <div style={styles.backdrop} onClick={onClose}>
        <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
          <div style={styles.header}>
            <h2 style={styles.title}>Emergency Contacts</h2>
            <button style={styles.closeBtn} onClick={onClose}>
              ✕
            </button>
          </div>

          {emergencyContacts.length === 0 ? (
            <p style={styles.noData}>No emergency contacts found.</p>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>S/N</th>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Phone Number</th>
                  <th style={styles.th}>Relationship</th>
                </tr>
              </thead>
              <tbody>
                {emergencyContacts.map((contact, index) => (
                  <tr key={index} style={styles.tr}>
                    <td style={styles.td}>{index + 1}</td>
                    <td style={styles.td}>{contact.Name}</td>
                    <td style={styles.td}>{contact.phoneNumber}</td>
                    <td style={styles.td}>{contact.relation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },

  modal: {
    backgroundColor: "#fff",
    width: "700px",
    maxWidth: "95%",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },

  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 600,
  },

  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    padding: "10px 12px",
    borderBottom: "2px solid #ddd",
    backgroundColor: "#f8f8f8",
    fontWeight: 600,
    fontSize: "14px",
    color: "black",
  },

  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #eee",
    fontSize: "14px",
  },

  tr: {
    backgroundColor: "#fff",
  },
  noData: {
    fontSize: "16px",
    color: "black",
    padding: "20px",
  },
};
